import { Struttura } from './struttura';
import { HmModelRest } from './abstract_model';
import { Utente } from './utente';

export const REGIONE_TOSCANA_ID = 9;

export class AreaVasta extends HmModelRest {
    static readonly rest_path = 'aree_vaste';
    id: number;
    nome: string;
    descrizione: string;
    logo: string; // immagine
    codice_cup: string;
    codice_azienda: number;
    referente: number | Utente;
}

export class AziendaSanitaria extends HmModelRest {
    static readonly rest_path = 'aziende_sanitarie';
    id: number;
    nome: string;
    descrizione: string;
    logo: string; // immagine
    codice_cup: string;
    codice_azienda: number;
    area_vasta: number;
    universitaria: boolean;
    referente: number | Utente;
}

export class Macrozona extends HmModelRest {
    static readonly rest_path = 'macrozone';

    id: number;
    nome: string;
    id_cup: number;
    codice_cup: string;
    codice_ex_azienda: string;
    area_vasta: number;
    azienda_sanitaria: number;
    referente: number | Utente;
}

export class Distretto extends HmModelRest {
    static readonly rest_path = 'distretti';

    id: number;
    nome: string;
    cup: string; // cup 1

    area_vasta: number;
    azienda_sanitaria: number;
    macrozona: number;

    id_cup: string;
    codice_cup: string;
    codice_interno: number;

    codice_lettera: string;
    codice_lettera_completo: string;

    referente: number | Utente;
    cup_attivo: boolean;
}

export class Comune extends HmModelRest {
    static readonly rest_path = 'comuni';
    id: number;
    nome: string;
    istat: string;

    distretto: number;
    consultorio: number;
    ospedale: number;
    provincia: number;
}

export class Provincia extends HmModelRest {
    static readonly rest_path = 'province';
    id: number;
    nome: string;
    sigla: string;

    regione: number;
    area_vasta: number;

}

export class Regione extends HmModelRest {
    static readonly rest_path = 'regioni';
    id: number;
    nome: string;
}

